import { useEffect, useState } from "react";
import moment from "moment";

import { Page, Container } from "@/ui/Layout/Page";
import { Grid } from "@/ui/Grid";
import { Card } from "@/ui/Card";
import { getCampaigns } from "@/api/campaigns";
import { ButtonTypes, Status } from "@/ui/types";
import { getSessionToken } from "@/api/auth";
import { Link } from "react-router-dom";
import Button from "@/ui/Button";
import { EmptyState } from "@/ui/Layout";
import { Loading } from "@/ui/Layout/Loading";

import { LAUNCH_OS_ICON } from "@/brand";
export const Webinar = ({ name = "" }) => {
  const [webinarCampaigns, setWebinarCampaigns] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // get the webinarCampaigns from the server
  const loadWebinarCampaigns = async () => {
    const token = getSessionToken();
    const response = await getCampaigns({ token, type: "webinar" });
    // const response = await getCampaigns({ token, type: "webinarCampaign" });
    if (response) {
      // convert the response to the format that the Card components expect
      const seqs = response
        ?.filter(({ deleted }) => !deleted)
        .map((webinarCampaign: any) => {
          return {
            id: webinarCampaign.id,
            label: webinarCampaign.name,
            caption: `Last Updated: ${moment(
              webinarCampaign.updatedAt
            ).fromNow()}`,
            img: (
              <img
                className="w-[42px] h-[42px] flex-none rounded-full overflow-hidden object-cover"
                src={LAUNCH_OS_ICON}
                alt=""
              />
            ), // funnel.screensnhot
            status: Status.INPROGRESS,
          };
        });

      setWebinarCampaigns(seqs);
    }
    setIsLoading(false);
  };

  // load the webinarCampaigns when the page loads
  useEffect(() => {
    loadWebinarCampaigns();
  }, []);

  return (
    <Page
      topBar={{
        page: [{ label: name }],
        items: (
          <Link to="/launchpad/webinar" className="justify-end">
            <Button
              label="+ Create a Webinar Campaign"
              type={ButtonTypes.OUTLINED}
            />
          </Link>
        ),
      }}
    >
      <Container>
        {isLoading && <Loading type="gallery" />}
        {!isLoading && !Boolean(webinarCampaigns.length) && (
          <EmptyState
            title="No Webinar Campaigns Yet"
            description="Get started by creating a new webinar."
            showImage={false}
          >
            <Link to="/launchpad/webinar">
              <Button
                label="Create a Webinar Campaign"
                type={ButtonTypes.DEFAULT}
              />
            </Link>
          </EmptyState>
        )}
        {!isLoading && Boolean(webinarCampaigns.length) && (
           <Grid className="pb-6">
            {/* Can we change to Gallery View - let's me toggle views */}
            {webinarCampaigns.map(
              (
                {
                  id,
                  label,
                  caption,
                  img = "[logo]",
                  status,
                  // sharedWith,
                  taskDetails,
                },
                key
              ) => {
                return (
                  <Card
                    key={key}
                    label={label}
                    caption={caption}
                    image={img}
                    href={`/webinar/${id}`}
                    status={status}
                    taskDetails={taskDetails}
                  />
                );
              }
            )}
          </Grid>
        )}
      </Container>
    </Page>
  );
};
